const qaConfigs = {
  ruleServerUrl: 'https://api.casaqa.ajira.tech',
  apiServerUrl: 'https://api.customerstudioqa.ajira.tech',
  dashboardUrl: 'https://dashboard.casaqa.ajira.tech',
  firebase: {
    config: {
      apiKey: 'AIzaSyCxwd86R5XS4fLw0es015OAJm77i8qZSdU',
      authDomain: 'pwa-79c5b.firebaseapp.com',
      projectId: 'pwa-79c5b',
      storageBucket: 'pwa-79c5b.appspot.com',
      messagingSenderId: '648508660907',
      appId: '1:648508660907:web:951232665fb807f4822bee',
    },
    vapidKey: 'BPalqcG7oYUb01X2Kgi-8SbrqL1eWKt89mnA_SEgTmgaiATL4azbeMFoDMmfH8iJmHUWCdwtnOPj6NTMlJkjNx4',
  },
}

export default qaConfigs
